module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_karuizawa-ddabf21c5ef1ade6b59d7f48dd985a44.jpg";